/** External dependencies */
// import { Handlebars } from 'handlebars/runtime';

export function replaceContent(parent) {
    const content = parent.querySelector('.ajaxcontent');
    const api = parent.dataset.restReplace;
    const nonce = document.body.dataset.restNonce;

    if (api && content) {
        const tmpl = parent.querySelector('.hbstmpl');

        if (!tmpl) {
            return;
        }

        jQuery
            .ajax({
                type: 'GET',
                url: api,
                beforeSend: (xhr) => {
                    if (nonce && nonce.length) {
                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                    }
                },
            })
            .done((result) => {
                const template = Handlebars.compile(tmpl.innerHTML);
                content.innerHtml = template(result);
                parent.classList.add('loaded');
            })
            .fail((result) => {
                console.warn(result);
            });
    }
}
